import React, { Component, ReactNode } from "react";

interface ErrorBoundaryProps {
  id?: string;
  fallback?: ReactNode;
  onError?: (error: Error, errorInfo: any) => void;
  children: ReactNode;
}

interface ErrorBoundaryState {
  error: Error | null;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, errorInfo: any): void {
    console.error(`Error from RemoteComponent #${this.props.id}:`, error);

    if (this.props.onError) {
      this.props.onError(error, errorInfo);
    }
  }

  render(): ReactNode {
    if (this.state.error) {
      if (this.props.fallback) {
        return this.props.fallback;
      } else {
        return <></>;
      }
    } else {
      return this.props.children;
    }
  }
}
